import { Link } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import {
  HOSPITAL_SERVICE_REGISTRY,
  serviceBillingLabel,
  type ServiceImplementationStatus,
} from "@/core/services/hospital-service-registry";
import { routes } from "@/router/all_routes";

const STATUS_LABELS: Record<ServiceImplementationStatus, string> = {
  live: "Opérationnel",
  partial: "Partiel",
  planned: "Prévu",
};

function statusBadgeClass(status: ServiceImplementationStatus): string {
  if (status === "live") return "text-bg-success";
  if (status === "partial") return "text-bg-warning";
  return "text-bg-secondary";
}

export function HospitalServicesHubPage() {
  const liveCount = HOSPITAL_SERVICE_REGISTRY.filter((s) => s.status === "live").length;

  return (
    <div>
      <PageHeader
        title="Services hospitaliers"
        description={`Vue d'ensemble des ${liveCount} modules opérationnels — gestion, flux et types de revenus.`}
        actions={
          <div className="ph-page-header-actions">
            <Link to={routes.dashboardFinance} className="btn btn-outline-primary btn-sm">
              Santé financière
            </Link>
          </div>
        }
      />

      <div className="row g-3">
        {HOSPITAL_SERVICE_REGISTRY.map((service) => (
          <div key={service.id} className="col-12 col-md-6 col-xl-4">
            <div className="ph-invoice-sheet ph-dash-card h-100 d-flex flex-column">
              <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                <h2 className="h6 fw-semibold mb-0">{service.label}</h2>
                <span className={`badge ${statusBadgeClass(service.status)}`}>
                  {STATUS_LABELS[service.status]}
                </span>
              </div>
              <p className="small text-muted flex-grow-1">{service.description}</p>
              {service.billingSource && (
                <p className="small mb-2">
                  <span className="text-muted">Revenu : </span>
                  <strong>{serviceBillingLabel(service.billingSource)}</strong>
                </p>
              )}
              <Link to={service.route} className="btn btn-sm btn-outline-primary align-self-start">
                Ouvrir →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
